import { Component, OnInit, Input } from '@angular/core';
import { DmCartItemEliminarModal } from '../dm-cart-item-eliminar-modal/dm-cart-item-eliminar-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DmCartItemDetalheModal } from '../dm-cart-item-detalhe-modal/dm-cart-item-detalhe-modal.component';

@Component({
  selector: 'dm-cart-item',
  templateUrl: './dm-cart-item.component.html',
  styleUrls: ['./dm-cart-item.component.scss']
})
export class DmCartItemComponent implements OnInit {

  @Input("item") item     = null;
  @Input("index") index   = null;
  public showPassageiros  = false;

  constructor(
    private dialog: MatDialog
  ){ 
  }
  /**
   * 
   * Detalhe
   * 
   */
  _openDetalhe(){

    this.dialog.open(
      DmCartItemDetalheModal,{ 
        width: "700px",
        height: "auto", 
        disableClose: true,  
        data: {
          item: this.item 
        }
      }
    )

  }
  /**
   * 
   * Editar
   * 
   */
  _openEditar(){

  

  }
  /**
   * 
   * Eliminar
   * 
   */
  _openEliminar(){

    this.dialog.open(
      DmCartItemEliminarModal,{ 
        width: "500px",
        height: "auto",
        disableClose: true, 
        data: {
          item: this.item 
        }
      }
    )

  }
  /**
   * 
   * Show passageiros
   * 
   */
  _showPassageiros(){

    this.showPassageiros = this.showPassageiros == true ? false : true;

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){

  }

}
